import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-wrong-route',
  templateUrl: './wrong-route.component.html',
  styleUrls: ['./wrong-route.component.css']
})
export class WrongRouteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
